import { inject, provideAppInitializer, EnvironmentProviders } from '@angular/core';
import { ExpiracionAbsolutaSesionService } from '@core/services/expiracion-absoluta-sesion/expiracion-absoluta-sesion.service';

export interface OpcionesExpiracionAbsolutaSesion {
  expiracionAbsolutaSesionService: ExpiracionAbsolutaSesionService;
}

export function activarExpiracionAbsolutaSesionAlArrancar(opciones: OpcionesExpiracionAbsolutaSesion): void {
  opciones.expiracionAbsolutaSesionService.activar();
}

export function proveedorExpiracionAbsolutaSesion(): EnvironmentProviders {
  return provideAppInitializer(() => {
    activarExpiracionAbsolutaSesionAlArrancar({
      expiracionAbsolutaSesionService: inject(ExpiracionAbsolutaSesionService),
    });
  });
}
